
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as index2SQL26eCbBGuxrF1Mhtie8HU5uS1Zgqd8NPvr2uuBaMMeta } from "/app/pages/id/index.vue?macro=true";
import { default as tipsYwWYi4R9UwAh97wwXxvIL3sTxVf3Z_45Uh5swokzDZMMIMeta } from "/app/pages/vip/tips.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta } from "/app/pages/news/[id].vue?macro=true";
import { default as indexzINJFZS6B9m435xzmrZtx0h_451rbXwDK3hGXnFMn25JAMeta } from "/app/pages/vip/index.vue?macro=true";
import { default as team9sUCLzPJP_45eEWQuwRmZwE142inR_45SY9sdfzxJSCP0ZoMeta } from "/app/pages/about/team.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
import { default as indexmDkZknZfC2JZIyF1wd32XvCsks7uhkxEEneeBDPo_45AoMeta } from "/app/pages/press/index.vue?macro=true";
import { default as parkingwXumPP8tadSZXh9yRnuhDatdZqVS7Z3PWay9qHj79ocMeta } from "/app/pages/vip/parking.vue?macro=true";
import { default as profilecV2372XXNw6hZyK4nO8Z0YnPjsMphAwEOt6NTZfQctUMeta } from "/app/pages/vip/profile.vue?macro=true";
import { default as _idUB10335UQG6mno2X5YDRBp8Vcp_45_45XomIfxypa2g797AMeta } from "/app/pages/vip/program/_id.vue?macro=true";
import { default as program2P1oTcAvPbR9zHzhXQk1MtRHEFu8moButcyjt5P6C7IMeta } from "/app/pages/vip/program.vue?macro=true";
import { default as welcome5gJsW0ZXE1eo_456Ly_kXhMky0CoFfDN2LTNG5oQADFCAMeta } from "/app/pages/vip/welcome.vue?macro=true";
import { default as calendarOly7UfoKmJAtN0m_KZ5h2RFZWKLGMyl52_ZSdHLAl5EMeta } from "/app/pages/vip/calendar.vue?macro=true";
import { default as contactsVVbSbYqAhK9wuWk_WSSMBOvY6lAmBb0U_BiH08RNIgEMeta } from "/app/pages/vip/contacts.vue?macro=true";
import { default as _id_3kJT0RfxnpD40Zn4BoRP_4544dC_iKYWI5C_45DLVVOvJMMeta } from "/app/pages/vip/parallel/_id.vue?macro=true";
import { default as parallelXDF4u0AI5KYoRSXPyMdG0hy09971jdFVkHbYFXDoCKwMeta } from "/app/pages/vip/parallel.vue?macro=true";
import { default as indexGjzlYWcy7LdtaYjVAktXX7GEbFYymXH7FgrHv8bNYwUMeta } from "/app/pages/experts/index.vue?macro=true";
import { default as indexcu9RRixiQhk3citi9tha2a9q9IhoGXufYxaKfcpJ_45KgMeta } from "/app/pages/program/index.vue?macro=true";
import { default as indexo3spBEKVcOAAnRYw14uDziYhGPGPfahlX3bWXhxhhesMeta } from "/app/pages/partners/index.vue?macro=true";
import { default as consultingwt1Yxl7wsjOaosB_xYKB_YEFsdmOrjkAi_1F0qy_wtgMeta } from "/app/pages/vip/consulting.vue?macro=true";
import { default as indexsRXgyT7wZTqGwl0_B2GFaPWGrR8P86BbQEv7AxlEe0kMeta } from "/app/pages/visitors/index.vue?macro=true";
import { default as rulesgTQaRx2XUZv6etrl2yzOBC_45FPX5vFwCh8B01aGpwS24Meta } from "/app/pages/visitors/rules.vue?macro=true";
import { default as _91_46_46_46slug_93Pq6Uo2Pgtr5unCQkYPwMgry8sHHML1pFbN1gcXymEccMeta } from "/app/pages/about/[...slug].vue?macro=true";
import { default as indexU5XFUcVA1UbS9gUzp8aN1KNylangaIBFxDoKZyDBERUMeta } from "/app/pages/galleries/index.vue?macro=true";
import { default as _91year_93dS93a_45UlosKnju9DAMQVzSFmolQ63ImUxJ6TtENaQwAMeta } from "/app/pages/partners/[year].vue?macro=true";
import { default as indexFI_45TPQ4YtvW5Lj3zxDbuU7iwPXSpdiCBASIAIdZ8L_45oMeta } from "/app/pages/vip/login/index.vue?macro=true";
import { default as workwithusRO0S9ITf_HzF68FyaYuVmKj3eoWcoQV3C5_45zviGq4TEMeta } from "/app/pages/about/workwithus.vue?macro=true";
import { default as indexBC_wwR1Iiu66mer6xTKJswMdxhAkWDZzZ_45y4gN8H9b0Meta } from "/app/pages/checkpoint/index.vue?macro=true";
import { default as indexb8RYnll03yO_2OeyZj1oJ97yXGryApE7J_96AlaFjJ8Meta } from "/app/pages/id/profile/index.vue?macro=true";
import { default as requestA4DNBhhvh4xZ74jJI1MEovNQ_LLRq78P9Zua0MFtZRYMeta } from "/app/pages/partners/request.vue?macro=true";
import { default as by_keyVb4ocknC1lq_45BgL2f8WXTNEMemHI3GcPHhhI1kavPJoMeta } from "/app/pages/vip/login/by_key.vue?macro=true";
import { default as registrationHIXXtJWX47cw_lExNjnc5pgHat5Yma7oAz4R2bGidXQMeta } from "/app/pages/vip/registration.vue?macro=true";
import { default as indexrUxJ_yY3Lo25SgcOHVIROn7O5wuA85nWrDxwyR3b9LUMeta } from "/app/pages/experts/_id/index.vue?macro=true";
import { default as index3aP_nMx563Mw_v_nQab9zJSQAcvD7qqZ_45yfgda5JVbkMeta } from "/app/pages/press/photo/index.vue?macro=true";
import { default as _91year_93gGbgi9riCc6zkMmzvN6RExwPnITqgI0MjmUhuL94afcMeta } from "/app/pages/press/photo/[year].vue?macro=true";
import { default as indexVJCp1KdYbG3CMveGoyAYaTCKCN3NP6rJf_45ZlsyIp7rMMeta } from "/app/pages/subscription/index.vue?macro=true";
import { default as indexw9JkxRvz8rprdsQ3ShMn5V8bRYB_4572U3yD2xsRtgZ7oMeta } from "/app/pages/experts/login/index.vue?macro=true";
import { default as index4toaIq14gxNhT1DDq9f8D7BL9i4V3vRj_45HSWAhWbP1YMeta } from "/app/pages/accounts/login/index.vue?macro=true";
import { default as indexUIB81ItZne_45Lv_FL8Vh4XwI7oxw99gc1SDsihZzYjWgMeta } from "/app/pages/galleries_data/index.vue?macro=true";
import { default as indexvUyd33jM7iZ6LxOQrpITRe4XwmI1jxDnXHIXNrhhwIAMeta } from "/app/pages/press/contacts/index.vue?macro=true";
import { default as index3o6XcCPtFtCUDvw0e8xjc4KSKHzsBoJEfddpXbUBNGEMeta } from "/app/pages/press/releases/index.vue?macro=true";
import { default as index6AMCMKesDdyBCFs4ZDdTIRa_PnY0nyMk4216jVviZsQMeta } from "/app/pages/program/[year]/index.vue?macro=true";
import { default as policy_agreementmWWHMUwNKspr2C6mi3T5wVC6dk9JGJjahKH7Hr63NWkMeta } from "/app/pages/vip/policy_agreement.vue?macro=true";
import { default as by_key6iOS5oIC5NrL4fX0BYdAUzmZ6y5qHcjeGCg9bQ0JNcIMeta } from "/app/pages/accounts/login/by_key.vue?macro=true";
import { default as index3XoWlXfcpgDjNXeBJEiS4TixKVPGTwEqM9cxT6TFAHoMeta } from "/app/pages/accounts/signup/index.vue?macro=true";
import { default as indexpv9ZP9CFopPm2Z_45zD08y7XAnqsW57HSlDrJ7LPFuzWUMeta } from "/app/pages/experts/profile/index.vue?macro=true";
import { default as _91year_93UlvlLjiOE1Xhh_45PPy7m_451P7zG57wfZHU0QWpUBAm9FcMeta } from "/app/pages/press/releases/[year].vue?macro=true";
import { default as partner_proposalsooV9Px0o2A5hMRWijWrlKAL4IV2UsBD3l9HozStjwHIMeta } from "/app/pages/vip/partner_proposals.vue?macro=true";
import { default as indexjn4ny_2tay8zlsEjR9CW0ehn_45YRZaGg_2WZRol0LDqQMeta } from "/app/pages/galleries/[year]/index.vue?macro=true";
import { default as area_not_availablecvyIiwleVAEO18tsMMR6TCxqvyuQNHCHcUZ7L1N1wdwMeta } from "/app/pages/vip/area_not_available.vue?macro=true";
import { default as indexwhXZlaIVpaxdrcXXDjOM7A9UMTtwq5M_Zl4TIhzSFmsMeta } from "/app/pages/press/publications/index.vue?macro=true";
import { default as _91_46_46_46token_93Hx4j_454SsBXUUc0GN_45CIvzPfCON1DYeF4VjvRSPAe8dYMeta } from "/app/pages/accounts/reset/[...token].vue?macro=true";
import { default as indexxSNQyQtCXE5u8k4BJhXFnghxa85TU5uvPi4GEbqjwn8Meta } from "/app/pages/press/accreditation/index.vue?macro=true";
import { default as _91year_93jE67tarHZn8QaCSi6GYcmP49FO1oRTA_45I7FqNitzs9cMeta } from "/app/pages/press/publications/[year].vue?macro=true";
import { default as indexamMpG4d4QXCxWlkN66AyBJ27l6k8gH4wpLMFc9SSQNgMeta } from "/app/pages/galleries_data/login/index.vue?macro=true";
import { default as index_453pslR9Rc0LuNroVycmkr8J1GbgXTKS_AqN81AANOCsMeta } from "/app/pages/galleries_data/start/index.vue?macro=true";
import { default as change_passwordkmj2sgDPc_IKYDbMyL5bWIyqd74Vsr_45IQQAir_45h8bzIMeta } from "/app/pages/id/profile/change_password.vue?macro=true";
import { default as indexqG20DE5YO58cbUUspz5rw77bZCX89Y0qDBAY1ZfWBsIMeta } from "/app/pages/experts/access_denied/index.vue?macro=true";
import { default as indexF2yXr4t7j7r1FdrvZGTT2mSEqSDW5FA_45DRGdu7ZdCKwMeta } from "/app/pages/galleries_data/guests/index.vue?macro=true";
import { default as by_key8CnfPS_iubiIn_VBicJtAZ3qqPRuUjAw6kzwgQeLSTMMeta } from "/app/pages/galleries_data/login/by_key.vue?macro=true";
import { default as _91category_id_93VTWfDulTMoJue3bPpC0Qg0pUua76vh0kWfQW52hBk78Meta } from "/app/pages/news/category/[category_id].vue?macro=true";
import { default as indexQAfR_45jmnCs3mSUSFXJKHP9Zkuj7CWuP4yc5IAdEjJ7MMeta } from "/app/pages/galleries_data/profile/index.vue?macro=true";
import { default as indexn9IemAq2aZXZPRMQQBY7QqDpqXsDi89_bMSVVppEN0UMeta } from "/app/pages/accounts/password_reset/index.vue?macro=true";
import { default as create_galleryOROHIiFrdLtEWhyUVtdXRyO_45UyOQTZar2aVZ2dKttm4Meta } from "/app/pages/galleries_data/create_gallery.vue?macro=true";
import { default as gallery_45_91id_93yAN09aQWFAxd8DJnh8BA7BrWwBguenslAj0b4JkdccUMeta } from "/app/pages/galleries/[year]/gallery-[id].vue?macro=true";
import { default as edittoYorvsc_na8dZUqAPOlWhf05M2DCw3miyI24SKPeAkMeta } from "/app/pages/galleries_data/_gallery_id/edit.vue?macro=true";
import { default as indexX1q_45rtDX0QIWS3GWhmZdKXcbGPV9r_RlGmHjeXxUwuAMeta } from "/app/pages/galleries_data/_gallery_id/index.vue?macro=true";
import { default as indexPSjsmmzjhr2zuTE5IH6Hpn2oHI9yh9T_45hHT0xFjhBfcMeta } from "/app/pages/galleries_data/registration/index.vue?macro=true";
import { default as step25WKmSot2srAPrp5_45DJrMe7prkRAXyjFJR8LG03X_rBoMeta } from "/app/pages/galleries_data/registration/step2.vue?macro=true";
import { default as payment1p1B_45gv39MGNg77vGVqHkp3D90motn2BVJGImOrqAu8Meta } from "/app/pages/galleries_data/_gallery_id/payment.vue?macro=true";
import { default as statusVjyBtgdGzEr41CJK_p35T9GR2D_kvS728SsrpQKTcRsMeta } from "/app/pages/galleries_data/registration/status.vue?macro=true";
import { default as project_45_91project_id_93_Z1jxP7vp66gxIFDqer_45V_454_OFa_457rgF5RGs509HTkMMeta } from "/app/pages/program/[year]/project-[project_id].vue?macro=true";
import { default as documentso_45rnGCncyDTmzdK2VSlfdxoBuu8P5otytmFi_JR3WDYMeta } from "/app/pages/galleries_data/_gallery_id/documents.vue?macro=true";
import { default as section_45_91section_id_93GoC5lzXqH0qCd1mymqHRhZpsfMeHu54kZXKt9oCVU8MMeta } from "/app/pages/galleries/[year]/section-[section_id].vue?macro=true";
import { default as category_45_91category_id_934vXJ_45ht2ZoCghRYCVecLsk9ztFIyRoLRzVUdPFwA1aEMeta } from "/app/pages/program/[year]/category-[category_id].vue?macro=true";
import { default as indexQRRKw7JT9yUdQEYQ8ZmDKvo75wlJZLFCYB2r6nQqRisMeta } from "/app/pages/galleries_data/_gallery_id/booth/index.vue?macro=true";
import { default as _agreement_idfC1pB9KxbdqadWNsgkqZFlUXsa5ECD3PTm1GFZxvQCgMeta } from "/app/pages/galleries_data/agreements/_agreement_id.vue?macro=true";
import { default as base_orderEa0dndZdvTwThL8O0eeadHa_6wuioFpYuzQeMmjZmkUMeta } from "/app/pages/galleries_data/_gallery_id/booth/base_order.vue?macro=true";
import { default as booth_plan34QKiwmKOdT4dPwk3YgoDUqF6eDV5f10XqMi2F73AxgMeta } from "/app/pages/galleries_data/_gallery_id/booth/booth_plan.vue?macro=true";
import { default as artists_and_worksveSm8vpV7ywD_2fmTSZ7t2zkcTG1J9VUbjHsq0HxploMeta } from "/app/pages/galleries_data/_gallery_id/artists_and_works.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "id___en",
    path: "/en/id/",
    component: () => import("/app/pages/id/index.vue")
  },
  {
    name: "id___ru",
    path: "/ru/id/",
    component: () => import("/app/pages/id/index.vue")
  },
  {
    name: "vip-tips___en",
    path: "/en/vip/tips/",
    component: () => import("/app/pages/vip/tips.vue")
  },
  {
    name: "vip-tips___ru",
    path: "/ru/vip/tips/",
    component: () => import("/app/pages/vip/tips.vue")
  },
  {
    name: "dynamic-fallback___en",
    path: "/en/:slug(.*)*/",
    meta: _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta || {},
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "dynamic-fallback___ru",
    path: "/ru/:slug(.*)*/",
    meta: _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta || {},
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "news-id___en",
    path: "/en/news/:id()/",
    meta: _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta || {},
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___ru",
    path: "/ru/news/:id()/",
    meta: _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta || {},
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "vip___en",
    path: "/en/vip/",
    component: () => import("/app/pages/vip/index.vue")
  },
  {
    name: "vip___ru",
    path: "/ru/vip/",
    component: () => import("/app/pages/vip/index.vue")
  },
  {
    name: "about-team___en",
    path: "/en/about/team/",
    meta: team9sUCLzPJP_45eEWQuwRmZwE142inR_45SY9sdfzxJSCP0ZoMeta || {},
    component: () => import("/app/pages/about/team.vue")
  },
  {
    name: "about-team___ru",
    path: "/ru/about/team/",
    meta: team9sUCLzPJP_45eEWQuwRmZwE142inR_45SY9sdfzxJSCP0ZoMeta || {},
    component: () => import("/app/pages/about/team.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login/",
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___ru",
    path: "/ru/auth/login/",
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "news___en",
    path: "/en/news/",
    meta: indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta || {},
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/ru/news/",
    meta: indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta || {},
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login/",
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login/",
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "press___en",
    path: "/en/press/",
    meta: indexmDkZknZfC2JZIyF1wd32XvCsks7uhkxEEneeBDPo_45AoMeta || {},
    component: () => import("/app/pages/press/index.vue")
  },
  {
    name: "press___ru",
    path: "/ru/press/",
    meta: indexmDkZknZfC2JZIyF1wd32XvCsks7uhkxEEneeBDPo_45AoMeta || {},
    component: () => import("/app/pages/press/index.vue")
  },
  {
    name: "vip-parking___en",
    path: "/en/vip/parking/",
    component: () => import("/app/pages/vip/parking.vue")
  },
  {
    name: "vip-parking___ru",
    path: "/ru/vip/parking/",
    component: () => import("/app/pages/vip/parking.vue")
  },
  {
    name: "vip-profile___en",
    path: "/en/vip/profile/",
    component: () => import("/app/pages/vip/profile.vue")
  },
  {
    name: "vip-profile___ru",
    path: "/ru/vip/profile/",
    component: () => import("/app/pages/vip/profile.vue")
  },
  {
    name: "vip-program___en",
    path: "/en/vip/program/",
    component: () => import("/app/pages/vip/program.vue"),
    children: [
  {
    name: "vip-program-_id___en",
    path: "_id/",
    component: () => import("/app/pages/vip/program/_id.vue")
  }
]
  },
  {
    name: "vip-program___ru",
    path: "/ru/vip/program/",
    component: () => import("/app/pages/vip/program.vue"),
    children: [
  {
    name: "vip-program-_id___ru",
    path: "_id/",
    component: () => import("/app/pages/vip/program/_id.vue")
  }
]
  },
  {
    name: "vip-welcome___en",
    path: "/en/vip/welcome/",
    component: () => import("/app/pages/vip/welcome.vue")
  },
  {
    name: "vip-welcome___ru",
    path: "/ru/vip/welcome/",
    component: () => import("/app/pages/vip/welcome.vue")
  },
  {
    name: "vip-calendar___en",
    path: "/en/vip/calendar/",
    component: () => import("/app/pages/vip/calendar.vue")
  },
  {
    name: "vip-calendar___ru",
    path: "/ru/vip/calendar/",
    component: () => import("/app/pages/vip/calendar.vue")
  },
  {
    name: "vip-contacts___en",
    path: "/en/vip/contacts/",
    component: () => import("/app/pages/vip/contacts.vue")
  },
  {
    name: "vip-contacts___ru",
    path: "/ru/vip/contacts/",
    component: () => import("/app/pages/vip/contacts.vue")
  },
  {
    name: "vip-parallel___en",
    path: "/en/vip/parallel/",
    component: () => import("/app/pages/vip/parallel.vue"),
    children: [
  {
    name: "vip-parallel-_id___en",
    path: "_id/",
    component: () => import("/app/pages/vip/parallel/_id.vue")
  }
]
  },
  {
    name: "vip-parallel___ru",
    path: "/ru/vip/parallel/",
    component: () => import("/app/pages/vip/parallel.vue"),
    children: [
  {
    name: "vip-parallel-_id___ru",
    path: "_id/",
    component: () => import("/app/pages/vip/parallel/_id.vue")
  }
]
  },
  {
    name: "experts___en",
    path: "/en/experts/",
    component: () => import("/app/pages/experts/index.vue")
  },
  {
    name: "experts___ru",
    path: "/ru/experts/",
    component: () => import("/app/pages/experts/index.vue")
  },
  {
    name: "program___en",
    path: "/en/program/",
    meta: indexcu9RRixiQhk3citi9tha2a9q9IhoGXufYxaKfcpJ_45KgMeta || {},
    component: () => import("/app/pages/program/index.vue")
  },
  {
    name: "program___ru",
    path: "/ru/program/",
    meta: indexcu9RRixiQhk3citi9tha2a9q9IhoGXufYxaKfcpJ_45KgMeta || {},
    component: () => import("/app/pages/program/index.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners/",
    meta: indexo3spBEKVcOAAnRYw14uDziYhGPGPfahlX3bWXhxhhesMeta || {},
    component: () => import("/app/pages/partners/index.vue")
  },
  {
    name: "partners___ru",
    path: "/ru/partners/",
    meta: indexo3spBEKVcOAAnRYw14uDziYhGPGPfahlX3bWXhxhhesMeta || {},
    component: () => import("/app/pages/partners/index.vue")
  },
  {
    name: "vip-consulting___en",
    path: "/en/vip/consulting/",
    component: () => import("/app/pages/vip/consulting.vue")
  },
  {
    name: "vip-consulting___ru",
    path: "/ru/vip/consulting/",
    component: () => import("/app/pages/vip/consulting.vue")
  },
  {
    name: "visitors___en",
    path: "/en/visitors/",
    meta: indexsRXgyT7wZTqGwl0_B2GFaPWGrR8P86BbQEv7AxlEe0kMeta || {},
    component: () => import("/app/pages/visitors/index.vue")
  },
  {
    name: "visitors___ru",
    path: "/ru/visitors/",
    meta: indexsRXgyT7wZTqGwl0_B2GFaPWGrR8P86BbQEv7AxlEe0kMeta || {},
    component: () => import("/app/pages/visitors/index.vue")
  },
  {
    name: "visitors-rules___en",
    path: "/en/visitors/rules/",
    meta: rulesgTQaRx2XUZv6etrl2yzOBC_45FPX5vFwCh8B01aGpwS24Meta || {},
    component: () => import("/app/pages/visitors/rules.vue")
  },
  {
    name: "visitors-rules___ru",
    path: "/ru/visitors/rules/",
    meta: rulesgTQaRx2XUZv6etrl2yzOBC_45FPX5vFwCh8B01aGpwS24Meta || {},
    component: () => import("/app/pages/visitors/rules.vue")
  },
  {
    name: "about-slug___en",
    path: "/en/about/:slug(.*)*/",
    meta: _91_46_46_46slug_93Pq6Uo2Pgtr5unCQkYPwMgry8sHHML1pFbN1gcXymEccMeta || {},
    component: () => import("/app/pages/about/[...slug].vue")
  },
  {
    name: "about-slug___ru",
    path: "/ru/about/:slug(.*)*/",
    meta: _91_46_46_46slug_93Pq6Uo2Pgtr5unCQkYPwMgry8sHHML1pFbN1gcXymEccMeta || {},
    component: () => import("/app/pages/about/[...slug].vue")
  },
  {
    name: "galleries___en",
    path: "/en/galleries/",
    meta: indexU5XFUcVA1UbS9gUzp8aN1KNylangaIBFxDoKZyDBERUMeta || {},
    component: () => import("/app/pages/galleries/index.vue")
  },
  {
    name: "galleries___ru",
    path: "/ru/galleries/",
    meta: indexU5XFUcVA1UbS9gUzp8aN1KNylangaIBFxDoKZyDBERUMeta || {},
    component: () => import("/app/pages/galleries/index.vue")
  },
  {
    name: "partners-year___en",
    path: "/en/partners/:year()/",
    meta: _91year_93dS93a_45UlosKnju9DAMQVzSFmolQ63ImUxJ6TtENaQwAMeta || {},
    component: () => import("/app/pages/partners/[year].vue")
  },
  {
    name: "partners-year___ru",
    path: "/ru/partners/:year()/",
    meta: _91year_93dS93a_45UlosKnju9DAMQVzSFmolQ63ImUxJ6TtENaQwAMeta || {},
    component: () => import("/app/pages/partners/[year].vue")
  },
  {
    name: "vip-login___en",
    path: "/en/vip/login/",
    meta: indexFI_45TPQ4YtvW5Lj3zxDbuU7iwPXSpdiCBASIAIdZ8L_45oMeta || {},
    component: () => import("/app/pages/vip/login/index.vue")
  },
  {
    name: "vip-login___ru",
    path: "/ru/vip/login/",
    meta: indexFI_45TPQ4YtvW5Lj3zxDbuU7iwPXSpdiCBASIAIdZ8L_45oMeta || {},
    component: () => import("/app/pages/vip/login/index.vue")
  },
  {
    name: "about-workwithus___en",
    path: "/en/about/workwithus/",
    meta: workwithusRO0S9ITf_HzF68FyaYuVmKj3eoWcoQV3C5_45zviGq4TEMeta || {},
    component: () => import("/app/pages/about/workwithus.vue")
  },
  {
    name: "about-workwithus___ru",
    path: "/ru/about/workwithus/",
    meta: workwithusRO0S9ITf_HzF68FyaYuVmKj3eoWcoQV3C5_45zviGq4TEMeta || {},
    component: () => import("/app/pages/about/workwithus.vue")
  },
  {
    name: "checkpoint___en",
    path: "/en/checkpoint/",
    component: () => import("/app/pages/checkpoint/index.vue")
  },
  {
    name: "checkpoint___ru",
    path: "/ru/checkpoint/",
    component: () => import("/app/pages/checkpoint/index.vue")
  },
  {
    name: "id-profile___en",
    path: "/en/id/profile/",
    meta: indexb8RYnll03yO_2OeyZj1oJ97yXGryApE7J_96AlaFjJ8Meta || {},
    component: () => import("/app/pages/id/profile/index.vue")
  },
  {
    name: "id-profile___ru",
    path: "/ru/id/profile/",
    meta: indexb8RYnll03yO_2OeyZj1oJ97yXGryApE7J_96AlaFjJ8Meta || {},
    component: () => import("/app/pages/id/profile/index.vue")
  },
  {
    name: "partners-request___en",
    path: "/en/partners/request/",
    meta: requestA4DNBhhvh4xZ74jJI1MEovNQ_LLRq78P9Zua0MFtZRYMeta || {},
    component: () => import("/app/pages/partners/request.vue")
  },
  {
    name: "partners-request___ru",
    path: "/ru/partners/request/",
    meta: requestA4DNBhhvh4xZ74jJI1MEovNQ_LLRq78P9Zua0MFtZRYMeta || {},
    component: () => import("/app/pages/partners/request.vue")
  },
  {
    name: "vip-login-by_key___en",
    path: "/en/vip/login/by_key/",
    component: () => import("/app/pages/vip/login/by_key.vue")
  },
  {
    name: "vip-login-by_key___ru",
    path: "/ru/vip/login/by_key/",
    component: () => import("/app/pages/vip/login/by_key.vue")
  },
  {
    name: "vip-registration___en",
    path: "/en/vip/registration/",
    component: () => import("/app/pages/vip/registration.vue")
  },
  {
    name: "vip-registration___ru",
    path: "/ru/vip/registration/",
    component: () => import("/app/pages/vip/registration.vue")
  },
  {
    name: "experts-_id___en",
    path: "/en/experts/_id/",
    component: () => import("/app/pages/experts/_id/index.vue")
  },
  {
    name: "experts-_id___ru",
    path: "/ru/experts/_id/",
    component: () => import("/app/pages/experts/_id/index.vue")
  },
  {
    name: "press-photo___en",
    path: "/en/press/photo/",
    meta: index3aP_nMx563Mw_v_nQab9zJSQAcvD7qqZ_45yfgda5JVbkMeta || {},
    component: () => import("/app/pages/press/photo/index.vue")
  },
  {
    name: "press-photo___ru",
    path: "/ru/press/photo/",
    meta: index3aP_nMx563Mw_v_nQab9zJSQAcvD7qqZ_45yfgda5JVbkMeta || {},
    component: () => import("/app/pages/press/photo/index.vue")
  },
  {
    name: "press-photo-year___en",
    path: "/en/press/photo/:year()/",
    meta: _91year_93gGbgi9riCc6zkMmzvN6RExwPnITqgI0MjmUhuL94afcMeta || {},
    component: () => import("/app/pages/press/photo/[year].vue")
  },
  {
    name: "press-photo-year___ru",
    path: "/ru/press/photo/:year()/",
    meta: _91year_93gGbgi9riCc6zkMmzvN6RExwPnITqgI0MjmUhuL94afcMeta || {},
    component: () => import("/app/pages/press/photo/[year].vue")
  },
  {
    name: "subscription___en",
    path: "/en/subscription/",
    meta: indexVJCp1KdYbG3CMveGoyAYaTCKCN3NP6rJf_45ZlsyIp7rMMeta || {},
    component: () => import("/app/pages/subscription/index.vue")
  },
  {
    name: "subscription___ru",
    path: "/ru/subscription/",
    meta: indexVJCp1KdYbG3CMveGoyAYaTCKCN3NP6rJf_45ZlsyIp7rMMeta || {},
    component: () => import("/app/pages/subscription/index.vue")
  },
  {
    name: "experts-login___en",
    path: "/en/experts/login/",
    component: () => import("/app/pages/experts/login/index.vue")
  },
  {
    name: "experts-login___ru",
    path: "/ru/experts/login/",
    component: () => import("/app/pages/experts/login/index.vue")
  },
  {
    name: "accounts-login___en",
    path: "/en/accounts/login/",
    meta: index4toaIq14gxNhT1DDq9f8D7BL9i4V3vRj_45HSWAhWbP1YMeta || {},
    component: () => import("/app/pages/accounts/login/index.vue")
  },
  {
    name: "accounts-login___ru",
    path: "/ru/accounts/login/",
    meta: index4toaIq14gxNhT1DDq9f8D7BL9i4V3vRj_45HSWAhWbP1YMeta || {},
    component: () => import("/app/pages/accounts/login/index.vue")
  },
  {
    name: "galleries_data___en",
    path: "/en/galleries_data/",
    component: () => import("/app/pages/galleries_data/index.vue")
  },
  {
    name: "galleries_data___ru",
    path: "/ru/galleries_data/",
    component: () => import("/app/pages/galleries_data/index.vue")
  },
  {
    name: "press-contacts___en",
    path: "/en/press/contacts/",
    meta: indexvUyd33jM7iZ6LxOQrpITRe4XwmI1jxDnXHIXNrhhwIAMeta || {},
    component: () => import("/app/pages/press/contacts/index.vue")
  },
  {
    name: "press-contacts___ru",
    path: "/ru/press/contacts/",
    meta: indexvUyd33jM7iZ6LxOQrpITRe4XwmI1jxDnXHIXNrhhwIAMeta || {},
    component: () => import("/app/pages/press/contacts/index.vue")
  },
  {
    name: "press-releases___en",
    path: "/en/press/releases/",
    meta: index3o6XcCPtFtCUDvw0e8xjc4KSKHzsBoJEfddpXbUBNGEMeta || {},
    component: () => import("/app/pages/press/releases/index.vue")
  },
  {
    name: "press-releases___ru",
    path: "/ru/press/releases/",
    meta: index3o6XcCPtFtCUDvw0e8xjc4KSKHzsBoJEfddpXbUBNGEMeta || {},
    component: () => import("/app/pages/press/releases/index.vue")
  },
  {
    name: "program-year___en",
    path: "/en/program/:year()/",
    meta: index6AMCMKesDdyBCFs4ZDdTIRa_PnY0nyMk4216jVviZsQMeta || {},
    component: () => import("/app/pages/program/[year]/index.vue")
  },
  {
    name: "program-year___ru",
    path: "/ru/program/:year()/",
    meta: index6AMCMKesDdyBCFs4ZDdTIRa_PnY0nyMk4216jVviZsQMeta || {},
    component: () => import("/app/pages/program/[year]/index.vue")
  },
  {
    name: "vip-policy_agreement___en",
    path: "/en/vip/policy_agreement/",
    component: () => import("/app/pages/vip/policy_agreement.vue")
  },
  {
    name: "vip-policy_agreement___ru",
    path: "/ru/vip/policy_agreement/",
    component: () => import("/app/pages/vip/policy_agreement.vue")
  },
  {
    name: "accounts-login-by_key___en",
    path: "/en/accounts/login/by_key/",
    meta: by_key6iOS5oIC5NrL4fX0BYdAUzmZ6y5qHcjeGCg9bQ0JNcIMeta || {},
    component: () => import("/app/pages/accounts/login/by_key.vue")
  },
  {
    name: "accounts-login-by_key___ru",
    path: "/ru/accounts/login/by_key/",
    meta: by_key6iOS5oIC5NrL4fX0BYdAUzmZ6y5qHcjeGCg9bQ0JNcIMeta || {},
    component: () => import("/app/pages/accounts/login/by_key.vue")
  },
  {
    name: "accounts-signup___en",
    path: "/en/accounts/signup/",
    meta: index3XoWlXfcpgDjNXeBJEiS4TixKVPGTwEqM9cxT6TFAHoMeta || {},
    component: () => import("/app/pages/accounts/signup/index.vue")
  },
  {
    name: "accounts-signup___ru",
    path: "/ru/accounts/signup/",
    meta: index3XoWlXfcpgDjNXeBJEiS4TixKVPGTwEqM9cxT6TFAHoMeta || {},
    component: () => import("/app/pages/accounts/signup/index.vue")
  },
  {
    name: "experts-profile___en",
    path: "/en/experts/profile/",
    component: () => import("/app/pages/experts/profile/index.vue")
  },
  {
    name: "experts-profile___ru",
    path: "/ru/experts/profile/",
    component: () => import("/app/pages/experts/profile/index.vue")
  },
  {
    name: "press-releases-year___en",
    path: "/en/press/releases/:year()/",
    meta: _91year_93UlvlLjiOE1Xhh_45PPy7m_451P7zG57wfZHU0QWpUBAm9FcMeta || {},
    component: () => import("/app/pages/press/releases/[year].vue")
  },
  {
    name: "press-releases-year___ru",
    path: "/ru/press/releases/:year()/",
    meta: _91year_93UlvlLjiOE1Xhh_45PPy7m_451P7zG57wfZHU0QWpUBAm9FcMeta || {},
    component: () => import("/app/pages/press/releases/[year].vue")
  },
  {
    name: "vip-partner_proposals___en",
    path: "/en/vip/partner_proposals/",
    component: () => import("/app/pages/vip/partner_proposals.vue")
  },
  {
    name: "vip-partner_proposals___ru",
    path: "/ru/vip/partner_proposals/",
    component: () => import("/app/pages/vip/partner_proposals.vue")
  },
  {
    name: "galleries-year___en",
    path: "/en/galleries/:year()/",
    meta: indexjn4ny_2tay8zlsEjR9CW0ehn_45YRZaGg_2WZRol0LDqQMeta || {},
    component: () => import("/app/pages/galleries/[year]/index.vue")
  },
  {
    name: "galleries-year___ru",
    path: "/ru/galleries/:year()/",
    meta: indexjn4ny_2tay8zlsEjR9CW0ehn_45YRZaGg_2WZRol0LDqQMeta || {},
    component: () => import("/app/pages/galleries/[year]/index.vue")
  },
  {
    name: "vip-area_not_available___en",
    path: "/en/vip/area_not_available/",
    component: () => import("/app/pages/vip/area_not_available.vue")
  },
  {
    name: "vip-area_not_available___ru",
    path: "/ru/vip/area_not_available/",
    component: () => import("/app/pages/vip/area_not_available.vue")
  },
  {
    name: "press-publications___en",
    path: "/en/press/publications/",
    meta: indexwhXZlaIVpaxdrcXXDjOM7A9UMTtwq5M_Zl4TIhzSFmsMeta || {},
    component: () => import("/app/pages/press/publications/index.vue")
  },
  {
    name: "press-publications___ru",
    path: "/ru/press/publications/",
    meta: indexwhXZlaIVpaxdrcXXDjOM7A9UMTtwq5M_Zl4TIhzSFmsMeta || {},
    component: () => import("/app/pages/press/publications/index.vue")
  },
  {
    name: "accounts-reset-token___en",
    path: "/en/accounts/reset/:token(.*)*/",
    meta: _91_46_46_46token_93Hx4j_454SsBXUUc0GN_45CIvzPfCON1DYeF4VjvRSPAe8dYMeta || {},
    component: () => import("/app/pages/accounts/reset/[...token].vue")
  },
  {
    name: "accounts-reset-token___ru",
    path: "/ru/accounts/reset/:token(.*)*/",
    meta: _91_46_46_46token_93Hx4j_454SsBXUUc0GN_45CIvzPfCON1DYeF4VjvRSPAe8dYMeta || {},
    component: () => import("/app/pages/accounts/reset/[...token].vue")
  },
  {
    name: "press-accreditation___en",
    path: "/en/press/accreditation/",
    meta: indexxSNQyQtCXE5u8k4BJhXFnghxa85TU5uvPi4GEbqjwn8Meta || {},
    component: () => import("/app/pages/press/accreditation/index.vue")
  },
  {
    name: "press-accreditation___ru",
    path: "/ru/press/accreditation/",
    meta: indexxSNQyQtCXE5u8k4BJhXFnghxa85TU5uvPi4GEbqjwn8Meta || {},
    component: () => import("/app/pages/press/accreditation/index.vue")
  },
  {
    name: "press-publications-year___en",
    path: "/en/press/publications/:year()/",
    meta: _91year_93jE67tarHZn8QaCSi6GYcmP49FO1oRTA_45I7FqNitzs9cMeta || {},
    component: () => import("/app/pages/press/publications/[year].vue")
  },
  {
    name: "press-publications-year___ru",
    path: "/ru/press/publications/:year()/",
    meta: _91year_93jE67tarHZn8QaCSi6GYcmP49FO1oRTA_45I7FqNitzs9cMeta || {},
    component: () => import("/app/pages/press/publications/[year].vue")
  },
  {
    name: "galleries_data-login___en",
    path: "/en/galleries_data/login/",
    meta: indexamMpG4d4QXCxWlkN66AyBJ27l6k8gH4wpLMFc9SSQNgMeta || {},
    component: () => import("/app/pages/galleries_data/login/index.vue")
  },
  {
    name: "galleries_data-login___ru",
    path: "/ru/galleries_data/login/",
    meta: indexamMpG4d4QXCxWlkN66AyBJ27l6k8gH4wpLMFc9SSQNgMeta || {},
    component: () => import("/app/pages/galleries_data/login/index.vue")
  },
  {
    name: "galleries_data-start___en",
    path: "/en/galleries_data/start/",
    component: () => import("/app/pages/galleries_data/start/index.vue")
  },
  {
    name: "galleries_data-start___ru",
    path: "/ru/galleries_data/start/",
    component: () => import("/app/pages/galleries_data/start/index.vue")
  },
  {
    name: "id-profile-change_password___en",
    path: "/en/id/profile/change_password/",
    meta: change_passwordkmj2sgDPc_IKYDbMyL5bWIyqd74Vsr_45IQQAir_45h8bzIMeta || {},
    component: () => import("/app/pages/id/profile/change_password.vue")
  },
  {
    name: "id-profile-change_password___ru",
    path: "/ru/id/profile/change_password/",
    meta: change_passwordkmj2sgDPc_IKYDbMyL5bWIyqd74Vsr_45IQQAir_45h8bzIMeta || {},
    component: () => import("/app/pages/id/profile/change_password.vue")
  },
  {
    name: "experts-access_denied___en",
    path: "/en/experts/access_denied/",
    component: () => import("/app/pages/experts/access_denied/index.vue")
  },
  {
    name: "experts-access_denied___ru",
    path: "/ru/experts/access_denied/",
    component: () => import("/app/pages/experts/access_denied/index.vue")
  },
  {
    name: "galleries_data-guests___en",
    path: "/en/galleries_data/guests/",
    component: () => import("/app/pages/galleries_data/guests/index.vue")
  },
  {
    name: "galleries_data-guests___ru",
    path: "/ru/galleries_data/guests/",
    component: () => import("/app/pages/galleries_data/guests/index.vue")
  },
  {
    name: "galleries_data-login-by_key___en",
    path: "/en/galleries_data/login/by_key/",
    component: () => import("/app/pages/galleries_data/login/by_key.vue")
  },
  {
    name: "galleries_data-login-by_key___ru",
    path: "/ru/galleries_data/login/by_key/",
    component: () => import("/app/pages/galleries_data/login/by_key.vue")
  },
  {
    name: "news-category-category_id___en",
    path: "/en/news/category/:category_id()/",
    meta: _91category_id_93VTWfDulTMoJue3bPpC0Qg0pUua76vh0kWfQW52hBk78Meta || {},
    component: () => import("/app/pages/news/category/[category_id].vue")
  },
  {
    name: "news-category-category_id___ru",
    path: "/ru/news/category/:category_id()/",
    meta: _91category_id_93VTWfDulTMoJue3bPpC0Qg0pUua76vh0kWfQW52hBk78Meta || {},
    component: () => import("/app/pages/news/category/[category_id].vue")
  },
  {
    name: "galleries_data-profile___en",
    path: "/en/galleries_data/profile/",
    component: () => import("/app/pages/galleries_data/profile/index.vue")
  },
  {
    name: "galleries_data-profile___ru",
    path: "/ru/galleries_data/profile/",
    component: () => import("/app/pages/galleries_data/profile/index.vue")
  },
  {
    name: "accounts-password_reset___en",
    path: "/en/accounts/password_reset/",
    meta: indexn9IemAq2aZXZPRMQQBY7QqDpqXsDi89_bMSVVppEN0UMeta || {},
    component: () => import("/app/pages/accounts/password_reset/index.vue")
  },
  {
    name: "accounts-password_reset___ru",
    path: "/ru/accounts/password_reset/",
    meta: indexn9IemAq2aZXZPRMQQBY7QqDpqXsDi89_bMSVVppEN0UMeta || {},
    component: () => import("/app/pages/accounts/password_reset/index.vue")
  },
  {
    name: "galleries_data-create_gallery___en",
    path: "/en/galleries_data/create_gallery/",
    component: () => import("/app/pages/galleries_data/create_gallery.vue")
  },
  {
    name: "galleries_data-create_gallery___ru",
    path: "/ru/galleries_data/create_gallery/",
    component: () => import("/app/pages/galleries_data/create_gallery.vue")
  },
  {
    name: "galleries-year-gallery-id___en",
    path: "/en/galleries/:year()/gallery-:id()/",
    meta: gallery_45_91id_93yAN09aQWFAxd8DJnh8BA7BrWwBguenslAj0b4JkdccUMeta || {},
    component: () => import("/app/pages/galleries/[year]/gallery-[id].vue")
  },
  {
    name: "galleries-year-gallery-id___ru",
    path: "/ru/galleries/:year()/gallery-:id()/",
    meta: gallery_45_91id_93yAN09aQWFAxd8DJnh8BA7BrWwBguenslAj0b4JkdccUMeta || {},
    component: () => import("/app/pages/galleries/[year]/gallery-[id].vue")
  },
  {
    name: "galleries_data-_gallery_id-edit___en",
    path: "/en/galleries_data/_gallery_id/edit/",
    component: () => import("/app/pages/galleries_data/_gallery_id/edit.vue")
  },
  {
    name: "galleries_data-_gallery_id-edit___ru",
    path: "/ru/galleries_data/_gallery_id/edit/",
    component: () => import("/app/pages/galleries_data/_gallery_id/edit.vue")
  },
  {
    name: "galleries_data-_gallery_id___en",
    path: "/en/galleries_data/_gallery_id/",
    component: () => import("/app/pages/galleries_data/_gallery_id/index.vue")
  },
  {
    name: "galleries_data-_gallery_id___ru",
    path: "/ru/galleries_data/_gallery_id/",
    component: () => import("/app/pages/galleries_data/_gallery_id/index.vue")
  },
  {
    name: "galleries_data-registration___en",
    path: "/en/galleries_data/registration/",
    component: () => import("/app/pages/galleries_data/registration/index.vue")
  },
  {
    name: "galleries_data-registration___ru",
    path: "/ru/galleries_data/registration/",
    component: () => import("/app/pages/galleries_data/registration/index.vue")
  },
  {
    name: "galleries_data-registration-step2___en",
    path: "/en/galleries_data/registration/step2/",
    component: () => import("/app/pages/galleries_data/registration/step2.vue")
  },
  {
    name: "galleries_data-registration-step2___ru",
    path: "/ru/galleries_data/registration/step2/",
    component: () => import("/app/pages/galleries_data/registration/step2.vue")
  },
  {
    name: "galleries_data-_gallery_id-payment___en",
    path: "/en/galleries_data/_gallery_id/payment/",
    component: () => import("/app/pages/galleries_data/_gallery_id/payment.vue")
  },
  {
    name: "galleries_data-_gallery_id-payment___ru",
    path: "/ru/galleries_data/_gallery_id/payment/",
    component: () => import("/app/pages/galleries_data/_gallery_id/payment.vue")
  },
  {
    name: "galleries_data-registration-status___en",
    path: "/en/galleries_data/registration/status/",
    component: () => import("/app/pages/galleries_data/registration/status.vue")
  },
  {
    name: "galleries_data-registration-status___ru",
    path: "/ru/galleries_data/registration/status/",
    component: () => import("/app/pages/galleries_data/registration/status.vue")
  },
  {
    name: "program-year-project-project_id___en",
    path: "/en/program/:year()/project-:project_id()/",
    meta: project_45_91project_id_93_Z1jxP7vp66gxIFDqer_45V_454_OFa_457rgF5RGs509HTkMMeta || {},
    component: () => import("/app/pages/program/[year]/project-[project_id].vue")
  },
  {
    name: "program-year-project-project_id___ru",
    path: "/ru/program/:year()/project-:project_id()/",
    meta: project_45_91project_id_93_Z1jxP7vp66gxIFDqer_45V_454_OFa_457rgF5RGs509HTkMMeta || {},
    component: () => import("/app/pages/program/[year]/project-[project_id].vue")
  },
  {
    name: "galleries_data-_gallery_id-documents___en",
    path: "/en/galleries_data/_gallery_id/documents/",
    component: () => import("/app/pages/galleries_data/_gallery_id/documents.vue")
  },
  {
    name: "galleries_data-_gallery_id-documents___ru",
    path: "/ru/galleries_data/_gallery_id/documents/",
    component: () => import("/app/pages/galleries_data/_gallery_id/documents.vue")
  },
  {
    name: "galleries-year-section-section_id___en",
    path: "/en/galleries/:year()/section-:section_id()/",
    meta: section_45_91section_id_93GoC5lzXqH0qCd1mymqHRhZpsfMeHu54kZXKt9oCVU8MMeta || {},
    component: () => import("/app/pages/galleries/[year]/section-[section_id].vue")
  },
  {
    name: "galleries-year-section-section_id___ru",
    path: "/ru/galleries/:year()/section-:section_id()/",
    meta: section_45_91section_id_93GoC5lzXqH0qCd1mymqHRhZpsfMeHu54kZXKt9oCVU8MMeta || {},
    component: () => import("/app/pages/galleries/[year]/section-[section_id].vue")
  },
  {
    name: "program-year-category-category_id___en",
    path: "/en/program/:year()/category-:category_id()/",
    meta: category_45_91category_id_934vXJ_45ht2ZoCghRYCVecLsk9ztFIyRoLRzVUdPFwA1aEMeta || {},
    component: () => import("/app/pages/program/[year]/category-[category_id].vue")
  },
  {
    name: "program-year-category-category_id___ru",
    path: "/ru/program/:year()/category-:category_id()/",
    meta: category_45_91category_id_934vXJ_45ht2ZoCghRYCVecLsk9ztFIyRoLRzVUdPFwA1aEMeta || {},
    component: () => import("/app/pages/program/[year]/category-[category_id].vue")
  },
  {
    name: "galleries_data-_gallery_id-booth___en",
    path: "/en/galleries_data/_gallery_id/booth/",
    component: () => import("/app/pages/galleries_data/_gallery_id/booth/index.vue")
  },
  {
    name: "galleries_data-_gallery_id-booth___ru",
    path: "/ru/galleries_data/_gallery_id/booth/",
    component: () => import("/app/pages/galleries_data/_gallery_id/booth/index.vue")
  },
  {
    name: "galleries_data-agreements-_agreement_id___en",
    path: "/en/galleries_data/agreements/_agreement_id/",
    component: () => import("/app/pages/galleries_data/agreements/_agreement_id.vue")
  },
  {
    name: "galleries_data-agreements-_agreement_id___ru",
    path: "/ru/galleries_data/agreements/_agreement_id/",
    component: () => import("/app/pages/galleries_data/agreements/_agreement_id.vue")
  },
  {
    name: "galleries_data-_gallery_id-booth-base_order___en",
    path: "/en/galleries_data/_gallery_id/booth/base_order/",
    component: () => import("/app/pages/galleries_data/_gallery_id/booth/base_order.vue")
  },
  {
    name: "galleries_data-_gallery_id-booth-base_order___ru",
    path: "/ru/galleries_data/_gallery_id/booth/base_order/",
    component: () => import("/app/pages/galleries_data/_gallery_id/booth/base_order.vue")
  },
  {
    name: "galleries_data-_gallery_id-booth-booth_plan___en",
    path: "/en/galleries_data/_gallery_id/booth/booth_plan/",
    component: () => import("/app/pages/galleries_data/_gallery_id/booth/booth_plan.vue")
  },
  {
    name: "galleries_data-_gallery_id-booth-booth_plan___ru",
    path: "/ru/galleries_data/_gallery_id/booth/booth_plan/",
    component: () => import("/app/pages/galleries_data/_gallery_id/booth/booth_plan.vue")
  },
  {
    name: "galleries_data-_gallery_id-artists_and_works___en",
    path: "/en/galleries_data/_gallery_id/artists_and_works/",
    component: () => import("/app/pages/galleries_data/_gallery_id/artists_and_works.vue")
  },
  {
    name: "galleries_data-_gallery_id-artists_and_works___ru",
    path: "/ru/galleries_data/_gallery_id/artists_and_works/",
    component: () => import("/app/pages/galleries_data/_gallery_id/artists_and_works.vue")
  }
]